/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 59);
/******/ })
/************************************************************************/
/******/ ({

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
This is the place for all scripts that are going to be used on the site, but are not a part of visualdiet app
ie. handling a burger menu open/close.
*/

var menu = document.querySelector('#js-burger');
var overlay = document.querySelector('.js-overlay-content');
var downloadContent = document.querySelector('.download_content');

menu.addEventListener('click', function (e) {
  menu.classList.toggle('is-active');
  overlay.classList.toggle('is-visible');

  // Toggle aria-expanded attribute value when the overlay is shown/hidden.
  var ariaState = menu.getAttribute("aria-expanded");
  var newAriaState = ariaState == "true" ? "false" : "true";
  menu.setAttribute("aria-expanded", newAriaState);
});

console.log(downloadContent);

downloadContent.addEventListener('click', function (e) {
  e.preventDefault();
  var file = e.target.dataset.file;

  if (window.ga !== undefined) {
    var tracker = window.ga.getAll()[0];
    tracker.send('event', 'content-download', file, new Date().toLocaleString('en-GB'));
  }

  window.open(e.target.href);
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// scripts.js